/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers } from 'recompose'
import _get from 'lodash/get'
import { connect } from 'react-redux'
import { reduxForm, reset } from 'redux-form'
import { ALERTS } from 'constants/alerts'
import { withLocalization } from 'hocs/localization'
import { onStartLogoutWithRedirect } from 'redux-app/actionCreators/auth'
import { changePassword } from 'api/client/actions/userSettings'
import { onShowError, createAlert } from 'redux-app/modules/alerts'
import { isUserUnableToUpdateInfo } from 'redux-app/selectors/user'
import { FIELD_NAMES } from './constants'
import { IValues } from './types'
import ChangePasswordForm from './ChangePasswordForm'

const FORM_NAME = 'changePassword'

export default compose(
  withLocalization('profile.settings.changePassword'),
  connect(
    state => ({
      isUserUnableToUpdateInfo: isUserUnableToUpdateInfo(state),
    }),
    {
      changePassword,
      onShowError,
      reset,
      createAlert,
      onStartLogoutWithRedirect,
    },
  ),
  withHandlers({
    onSubmit: ({ changePassword, onShowError, reset, createAlert, onStartLogoutWithRedirect }) => formValues => {
      return changePassword(formValues)
        .then(() => {
          createAlert({ name: ALERTS.successChangePassword })
          reset(FORM_NAME)
          onStartLogoutWithRedirect()
        })
        .catch(error => {
          onShowError(error)
        })
    },
  }),
  reduxForm({
    form: FORM_NAME,
    validate: (values: IValues, { getTextPath }) => {
      const errors: any = {}
      const currentPassword = _get(values, FIELD_NAMES.currentPassword)
      if (currentPassword && currentPassword === _get(values, FIELD_NAMES.newPassword)) {
        errors[FIELD_NAMES.newPassword] = [getTextPath('errors.newPasswordMatch')]
      }
      return errors
    },
  }),
)(ChangePasswordForm)
